import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'
import { cloneDeep } from 'es-toolkit'

const globalSettings: Settings.all = {
  app: {
    // 固定项目主题为蓝色，避免默认进入橙色/绿色主题
    themeSync: true,
    lightTheme: 'blue',
    darkTheme: 'blue',
    colorScheme: 'light',
    enablePermission: true,
    enableCheckUpdates: false,
  },
  menu: {
    mode: 'head',
  },
  topbar: {
    mode: 'fixed',
  },
  toolbar: {
    notification: true,
    i18n: true,
    pageReload: true,
    cloudResources: false,
    chatPlugin: false,
  },
  mainPage: {
    enableHotkeys: false,
  },
  navSearch: {
    enableHotkeys: false,
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
